module.exports = __webpack_public_path__ + "img/hu.85015780.svg";